import React, { useContext, useEffect } from "react";
import BarChart from "./barCharts";

//import context
import { MyContext } from "../../../../tenantsDashContext";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const PropertyCard = () => {
  const { currentProperty, setCurrentProperty } = useContext(MyContext);

  useEffect(() => {
    console.log("current property", currentProperty);
  }, [currentProperty]);

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
    });
  };

  // Helper function to truncate names
  const truncateName = (name, maxLength = 14) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + "...";
  };

  // Helper function to get tenant image
  const getTenantImage = (tenant) => {
    if (tenant.user.image && tenant.user.image.length > 0) {
      return `${process.env.REACT_APP_IMAGE_ENDPOINT}/${tenant.user.image[0]}`;
    }
    return null;
  };

  // Get recent tenants (limit to 5)
  const getRecentTenants = () => {
    if (!currentProperty?.houses) return [];

    return currentProperty.houses
      .filter((house) => house.tenant)
      .slice(0, 5)
      .map((house) => ({
        name: house.tenant.user.name,
        houseNo: house.house_no,
        entryDate: house.tenant.entry_date,
        image: getTenantImage(house.tenant),
      }));
  };

  // Get caretaker name (first role_taker or default)
  const getCaretakerName = () => {
    if (
      currentProperty?.role_takers &&
      currentProperty.role_takers.length > 0
    ) {
      return currentProperty.role_takers[0].name || "Caretaker";
    }
    return "No caretaker set yet"; // Default fallback
  };

  const styles = {
    everything: {
      // minHeight: "100%",
      width: "92%",
      borderRadius: vw(10),
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      padding: vh(15),
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      // justifyContent:"center"
    },
    top: {
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      fontFamily: "Poppins, sans san-serif",
      fontSize: vh(16),
      fontWeight: "400",
    },
    firstSection: {
      width: "100%",
      height: "30%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      marginTop: vh(10),
    },
    borderAround: {
      padding: vh(15),
      border: "1px solid #DCDCDC",
      borderRadius: "50%",
    },
    profilePicture: {
      height: vh(120),
      width: vh(120),
      borderRadius: "50%",
      backgroundColor: "#192a3a",
    },
    profileTexts: {
      marginTop: vh(10),
      textAlign: "center",
    },
    caretakerName: {
      fontSize: vh(20),
      fontFamily: "Karla, sans san-serif",
      fontWeight: "400",
      color: "192a3a",
    },
    propertyName: {
      fontSize: vh(16),
      fontFamily: "Karla, sans san-serif",
      fontWeight: "400",
      color: "#9D9D9D",
    },
    graphSection: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "start",
      // paddingTop: "10%",
      // backgroundColor: "#dcdcdc",
      marginTop: vh(20),
      borderRadius: vw(10),
    },
    recentEnlistings: {
      marginTop: vh(30),
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#f9f9f9",
      padding: vh(15),
      borderRadius: vw(10),
    },
    titleContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: vh(10),
    },

    recentEnlistingsContainer: {
      // border: "0.5px solid #ddd",
      /* box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1); */
      width: "100%",
      borderRadius: vw(10),
    },
    individualTenant: {
      width: "95%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      fontSize: vh(18),
      fontWeight: "400",
      fontFamily: "Karla, sans-serif",
      transition: "background-color 0.3s ease",
      marginBottom: vh(10),
    },
    shapeAndDetails: {
      width: "100%",
      display: "flex",
      gap: vw(10),
      // justifyContent: "space-between",
    },
    shape: {
      width: vh(45),
      height: vh(45),
      borderRadius: "50%",
      backgroundColor: "#192a3a",
    },
    tenantImage: {
      width: vh(45),
      height: vh(45),
      borderRadius: "50%",
      objectFit: "cover",
    },
    nameAndDate: {
      display: "flex",
      flexDirection: "column",
    },
    name: {
      fontSize: vh(18),
      fontWeight: "400",
      fontFamily: "Karla, sans-serif",
    },
    date: {
      fontSize: vh(16),
      fontFamily: "Roboto, sans-serif",
      color: "#a8b4cc",
      fontWeight: "200",
      marginTop: vh(2),
    },
    roomNumber: {
      color: "#b39359",
    },
  };

  const recentTenants = getRecentTenants();

  return (
    <div style={styles.everything}>
      <div style={styles.top}>
        <div style={styles.title}>Statistics</div>
      </div>
      <div style={styles.firstSection}>
        <div style={styles.borderAround}>
          <div style={styles.profilePicture}></div>
        </div>
        <div style={styles.profileTexts}>
          <div style={styles.caretakerName}>{getCaretakerName()}</div>
          <div style={styles.propertyName}>
            {currentProperty?.name || "Property Name"} -{" "}
            {currentProperty?.location || "Location"}
          </div>
        </div>
      </div>
      <div style={styles.graphSection}>
        <BarChart />
      </div>
      <div style={styles.recentEnlistings}>
        <div style={styles.titleContainer}>
          <div style={styles.caretakerName}>Recent Enlistings</div>
        </div>
        <div style={styles.recentEnlistingsContainer}>
          {recentTenants.length > 0 ? (
            recentTenants.map((tenant, index) => (
              <div key={index} style={styles.individualTenant}>
                <div style={styles.shapeAndDetails}>
                  {tenant.image ? (
                    <img
                      src={tenant.image}
                      alt={tenant.name}
                      style={styles.tenantImage}
                    />
                  ) : (
                    <div style={styles.shape}></div>
                  )}
                  <div style={styles.nameAndDate}>
                    <div style={styles.name}>{truncateName(tenant.name)}</div>
                    <div style={styles.date}>
                      {formatDate(tenant.entryDate)}
                    </div>
                  </div>
                </div>
                <div style={styles.roomNumber}>{tenant.houseNo}</div>
              </div>
            ))
          ) : (
            <div style={styles.individualTenant}>
              <div style={styles.shapeAndDetails}>
                <div style={styles.nameAndDate}>
                  <div style={styles.name}>No recent enlistings</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
